const largeButtonLayouts = ['1_GRID', '2_GRID'];

export { largeButtonLayouts };
